// src/api/website-api/web-report.js
import axios from "axios";

const WEB_REPORT_API =
  `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/vendor/reports`;

/**
 * Get language from localStorage
 * supports: en / ar
 */
const getLang = () => {
  const lang = (localStorage.getItem("lang") || "en").toLowerCase();
  return lang.startsWith("ar") ? "ar" : "en";
};

/**
 * Build language headers
 * English = 1
 * Arabic = 4
 */
const getLanguageHeaders = () => {
  const lang = getLang();

  return {
    "Accept-Language": lang,
    "Language-ID": lang === "ar" ? 4 : 1,
  };
};

/**
 * Common headers
 */
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken");
  const storeId = localStorage.getItem("storeId");

  const headers = {
    ...getLanguageHeaders(),
  };

  if (token) headers.Authorization = `Bearer ${token}`;
  if (storeId) headers["Store-ID"] = storeId;

  return headers;
};

const buildParams = ({ start_date, end_date } = {}) => {
  const params = {};

  if (start_date) {
    params.start_date = start_date;
    params.date_from = start_date;
    params.from = start_date;
  }

  if (end_date) {
    params.end_date = end_date;
    params.date_to = end_date;
    params.to = end_date;
  }

  return params;
};

/**
 * SALES REPORT
 */
export const fetchSalesReport = async ({ start_date, end_date } = {}) => {
  const res = await axios.get(`${WEB_REPORT_API}/sales/`, {
    headers: getAuthHeaders(),
    params: buildParams({ start_date, end_date }),
  });

  return res.data;
};

/**
 * DAILY BREAKDOWN REPORT
 * (same sales endpoint; consumer reads daily_breakdown from response)
 */
export const fetchDailyBreakdownReport = async ({ start_date, end_date } = {}) => {
  const res = await axios.get(`${WEB_REPORT_API}/sales/`, {
    headers: getAuthHeaders(),
    params: buildParams({ start_date, end_date }),
  });

  return res.data;
};

/**
 * PRODUCTS REPORT
 */
export const fetchProductsReport = async ({
  start_date,
  end_date,
  limit = 10,
} = {}) => {
  const res = await axios.get(`${WEB_REPORT_API}/products/`, {
    headers: getAuthHeaders(),
    params: {
      limit,
      ...buildParams({ start_date, end_date }),
    },
  });

  return res.data;
};

/**
 * CASHIER PERFORMANCE REPORT
 */
export const fetchCashierPerformanceReport = async ({
  start_date,
  end_date,
} = {}) => {
  const res = await axios.get(`${WEB_REPORT_API}/cashier-performance/`, {
    headers: getAuthHeaders(),
    params: buildParams({ start_date, end_date }),
  });

  return res.data;
};

export { getLang };
